import React, { Component } from "react";
import { connect } from "react-redux";
import store from "../../../store";
import jwt_decode from "jwt-decode";
import setAuthToken from "../../../utils/setAuthToken";
import {
  loginUser,
  setCurrentUser,
  logoutUser
} from "../../../actions/authActions";
import {
  Layout,
  Row,
  Col,
  Button,
  Form,
  Input,
  Icon,
  notification
} from "antd";
import styled from "styled-components";

const FormItem = Form.Item;

const CustomLayout = styled(Layout)`
  && {
    min-height: 100vh;
    width: 100vw;
    background: rgb(0, 69, 124);
  }
`;

const CustomRow = styled(Row)`
  && {
    background: #fff;
    width: 80%;
    border-radius: 15px;
    margin: 100px auto;

    @media (min-width: 768px) {
      width: 75%;
    }

    @media (min-width: 992px) {
      width: 50%;
    }

    @media (min-width: 1200px) {
      width: 40%;
    }
  }
`;

const CustomCol = styled(Col)`
  && {
    padding: 15px;
    box-shadow: rgba(0, 0, 0, 0.8) 0 20px 60px -10px;

    @media (min-width: 768px) {
      padding: 25px;
    }

    @media (min-width: 992px) {
      padding: 50px;
    }
  }
`;

const FormInput = styled(FormItem)`
  && {
    width: 100%;
    margin: ${props => (props.top ? "25px 0 0 0" : "0 0 25px 0")};

    @media (min-width: 768px) {
      margin: ${props => (props.top ? "25px auto 0 auto" : "0 auto 0 auto")};
      width: 85%;
    }

    @media (min-width: 992px) {
      margin: ${props => (props.top ? "25px auto 0 auto" : "0 auto 0 auto")};
      width: 65%;
    }
  }

  div input {
    border-radius: 15px;
    background: #dfe6e9;
    border: none;

    ::placeholder {
      color: rgba(0, 0, 0, 0.65);
    }
  }
`;

const CustomButton = styled(Button)`
  && {
    color: #fff;
    border: none;
    background-color: ${props => props.bgcolor};
    display: block;
    width: 100%;
    white-space: normal;
    height: 50px;
    border-radius: 15px;

    :hover {
      background-color: ${props => props.bgcolor};
    }

    @media (min-width: 768px) {
      margin: 25px auto 0 auto;
    }

    @media (min-width: 992px) {
      margin: 25px auto 0 auto;
    }
  }
`;

const Logo = styled.img`
  display: block;
  margin: 0px auto 25px auto;
  width: 90%;

  @media (min-width: 768px) {
    width: auto;
  }
`;

class AdminLogin extends Component {
  componentDidMount = () => {
    if (this.props.auth.isAuthenticated) {
      this.props.history.push("/admin-dashboard");
    }

    if (localStorage.jwtToken) {
      setAuthToken(localStorage.jwtToken);
      const decoded = jwt_decode(localStorage.jwtToken);
      store.dispatch(setCurrentUser(decoded));

      const currTime = Date.now() / 1000;
      if (decoded.exp < currTime) {
        store.dispatch(logoutUser());
        this.props.history.push("/admin");
        notification.warning({
          message: "Login Expired",
          description: "You've been logged out"
        });
      }
    }
  };

  componentDidUpdate = prevProps => {
    if (this.props.auth.isAuthenticated !== prevProps.auth.isAuthenticated) {
      this.props.history.push("/admin-dashboard");
    }
  };

  render() {
    const WrappedAdminLoginForm = Form.create()(AdminLoginForm);

    return (
      <div>
        <CustomLayout>
          <CustomRow type="flex" justify="center">
            <CustomCol span={24}>
              <Logo src="/assets/img/hcdelogo.png" />
              <h1 style={{ textAlign: "center" }}>Administrator Login</h1>
              <WrappedAdminLoginForm loginUser={this.props.loginUser} />
            </CustomCol>
          </CustomRow>
        </CustomLayout>
      </div>
    );
  }
}

class AdminLoginForm extends Component {
  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const loginRequest = Object.assign({}, values);

        this.props.loginUser(loginRequest);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Col span={24}>
          <FormInput top={true}>
            {getFieldDecorator("username", {
              rules: [
                { required: true, message: "Please input your Username!" }
              ]
            })(
              <Input
                prefix={
                  <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="Enter your username"
              />
            )}
          </FormInput>
          <FormInput>
            {getFieldDecorator("password", {
              rules: [
                { required: true, message: "Please input your Password!" }
              ]
            })(
              <Input
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="Enter your password"
                type="password"
              />
            )}
          </FormInput>
          <FormInput>
            <CustomButton
              htmlType="submit"
              bgcolor="#0984e3"
              size="small"
              type="primary"
            >
              Login
            </CustomButton>
          </FormInput>
        </Col>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { loginUser }
)(AdminLogin);
